import { useActionsSummaryStatisticsWorkflow } from "@/api/useWorkflow"
import { ActionsTakenWidgetComponent } from "./ActionsTakenWidgetComponent"

export const ActionsTakenWidget = () => {
  const context = useActionsSummaryStatisticsWorkflow()
  const { isLoading, response } = context
  const { data } = response || {}

  return <ActionsTakenWidgetComponent {...data} isLoading={isLoading} />
}
